import { getAnalyticsWebClient } from 'util/analytics';
import { isInvestigateStatsigGroupAssignmentWarningEnabled } from 'feature-flags';
import FeatureGates, { FeatureGateEnvironment } from '@atlassian/feature-gate-js-client';
import { getMeta } from '@atlassian/help-center-common-util/meta';
import type { WindowFlagVars } from '../types';
import { getFeatureFlagsFromMetaTag } from '../utils';

export function initialiseFeatureGates(vars: WindowFlagVars) {
    if (FeatureGates.initializeCalled()) {
        return Promise.resolve();
    }
    try {
        const cloudId = getMeta('tenant-id') ?? undefined;
        const atlassianAccountId = getMeta('ajs-atlassian-account-id');

        // Please Delete it after investigation is finished.
        if (isInvestigateStatsigGroupAssignmentWarningEnabled() && !atlassianAccountId) {
            const statsigVars = vars.statsigValues || getFeatureFlagsFromMetaTag('ajs-fe-statsig-values');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const keys: any = statsigVars?.evaluated_keys;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            const backendIdentifiers = keys?.customIDs;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            const atlassianAccountIdBE = backendIdentifiers?.atlassianAccountId;
            if (atlassianAccountIdBE) {
                const analyticsClient = getAnalyticsWebClient();
                analyticsClient
                    .getInstance()
                    .sendOperationalEvent({
                        source: 'HelpCenter',
                        action: 'invalid',
                        actionSubject: 'statsigBootstrap',
                        attributes: {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                            backendIdentifiers,
                            message:
                                'Statsig invalid bootstrap: AAID mismatch between server side & client side. Client side is undefined, while server side is not',
                        },
                    })
                    .catch((err) => Promise.reject(err));
            }
        }
        // End of investigation code

        const region = getMeta('ajs-region');
        const environment =
            region !== undefined && region?.startsWith('prod')
                ? FeatureGateEnvironment.Production
                : FeatureGateEnvironment.Staging;

        return FeatureGates.initializeFromValues(
            {
                environment,
                targetApp: 'jsm-portal_web',
                sdkKey:
                    environment === FeatureGateEnvironment.Production
                        ? 'client-NKfwskfcfrondp65Ar9Mfv9GNLywVcUdkBvK1mLpNK6'
                        : 'client-rRwj0kwrHSPVA9p8Gy6pMfyBouOlfD2DX6pMXJtx9y1',
            },
            {
                atlassianAccountId: atlassianAccountId !== null ? atlassianAccountId : undefined,
                tenantId: cloudId,
            },
            {},
            vars.statsigValues || getFeatureFlagsFromMetaTag('ajs-fe-statsig-values')
        );
    } catch (error) {
        return Promise.reject(error);
    }
}
